module.exports = __webpack_public_path__ + "static/media/partners.6f63088e.svg";